// extracted by mini-css-extract-plugin
export default {"icon-wrapper":"Icon_icon-wrapper__IlXgS"};